import SetsPage from './SetsPage';
import BatchControlPage from './BatchControlPage';

export {
  BatchControlPage,
};

export default SetsPage;
